import * as user from "./user";
import * as permission from "./permission";
import * as tasks from "./tasks";
import * as invoice from "./invoice";
import * as oauth from "./oauth";
import * as home from "./home";
import * as coupon from "./coupon";

const api = {
  ...user,
  ...permission,
  ...tasks,
  ...invoice,
  ...oauth,
  ...home,
  ...coupon
};

export default api;
